<template>
    <div class="row mx-2 my-3 pricelist-settings">
        <div class="col-md-12">
            <div class="row">
                <div class="col-sm-12 col-md-7">
                    <h3>Default Settings</h3>
                </div>
                <div class="col-sm-12 col-md-3 text-right">
                    
                </div>
                <div class="col-sm-12 col-md-2 text-right">
                    
                </div>
            </div>

            <div class="row my-5">
                <div class="col-sm-12">
                    <div class="text-lg">Bought <b>{{ bought_suppressors }}</b> Suppressors in <b>{{ bought_in_days }}</b> Days</div>
                    <div class="text-lg">Sold <b>{{ sold_suppressors }}</b> Suppressors in <b>{{ sold_in_days }}</b> Days</div>
                    <span
                        v-if="user.role.id == 1"
                        class="add-button btn btn-action mt-3"
                        @click="openModal(null, 'edit', true)"
                    >
                        <i
                            class="fa fa-plus-circle"
                            aria-hidden="true"
                        ></i>
                        Update Default Setting
                    </span>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12 col-md-7">
                    <h3>Dealer Settings</h3>
                </div>
                <div class="col-sm-12 col-md-3 text-right">
                    
                </div>
                <div class="col-sm-12 col-md-2 text-right">
                    <span
                        v-if="user.role.id == 1"
                        class="add-button btn btn-action"
                        @click="openModal(null, 'add', false)"
                    >
                        <i
                            class="fa fa-plus-circle"
                            aria-hidden="true"
                        ></i>
                        ADD FLAG SETTING
                    </span>
                </div>
            </div>
            <table
                class="table table-responsive table-striped border-bottom mt-2"
            >
                <thead class="thead-light">
                    <tr>
                        <!-- <th>User</th> -->
                        <th class="w-50">Dealer</th>
                        <th class="w-50">Settings</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="flagSetting in paginatedFlagSettings" :key="flagSetting.id">
                        <!-- <td>{{ flagSetting.location?.name }}</td> -->
                        <td class="hyperlink" @click="openModal(flagSetting, 'edit', false)">
                            {{ flagSetting.location?.name }}
                        </td>
                        <td>
                            <div>
                                <span class="text-md">Bought <b>{{ flagSetting.bought_suppressors }}</b> Suppressors in <b>{{ flagSetting.bought_in_days }}</b> Days, </span>
                                <span class="text-md">Sold <b>{{ flagSetting.sold_suppressors }}</b> Suppressors in <b>{{ flagSetting.sold_in_days }}</b> Days</span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <!-- Pagination -->
            <table-pagination
                v-model="paginatedFlagSettings"
                :all-rows="searchAllFlagSettingsbyTerm"
                :perPage="perPage"
                @updateRow="updateRow"
            >
            </table-pagination>
        </div>

        <!-- Confirmation modal -->
        <b-modal
            v-model="modalShow"
            :title="modalType == 'add' ? 'ADD FLAG SETTING' : 'EDIT FLAG SETTING'"
            hide-footer
        >
            <SpeqFlagSettingModal
                v-if="modalShow"
                :modal-data="modalData"
                :modal-type="modalType"
                :modal-setting="modalSetting"
                @close-modal="closeModal"
            />
        </b-modal>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import TablePagination from "@/components/TablePagination.vue";

import SpeqFlagSettingModal from "@/components/speq/modals/SpeqFlagSettingModal.vue";

export default {
    props: [],
    emits: [],
    components: {
        TablePagination,
        SpeqFlagSettingModal,
    },
    setup() {
        const store = useStore();
        const route = useRoute();

        let user = computed(function () {
            return store.state.user;
        });

        let allFlagSettings = computed(function () {
            return store.state["flagSetting"].allFlagSettings;
        });

        let bought_suppressors = computed(function () {
            return store.state["flagSetting"].bought_suppressors;
        });

        let bought_in_days = computed(function () {
            return store.state["flagSetting"].bought_in_days;
        });


        let sold_suppressors = computed(function () {
            return store.state["flagSetting"].sold_suppressors;
        });


        let sold_in_days = computed(function () {
            return store.state["flagSetting"].sold_in_days;
        });


        function getAllFlagSettings() {
            store.dispatch("flagSetting/getAllFlagSettings");
        }

        onMounted(() => {});

        return {
            store,
            route,
            user,
            allFlagSettings,
            bought_suppressors,
            bought_in_days,
            sold_suppressors,
            sold_in_days,
            getAllFlagSettings,
        };
    },
    data() {
        return {
            paginatedFlagSettings: [],
            perPage: 50,
            searchTerm: "",
            modalShow: false,
            modalType: null,
            modalSetting: null,
            modalData: {},
        };
    },
    computed: {
        searchAllFlagSettingsbyTerm() {
            if (this.searchTerm === "") {
                return this.allFlagSettings;
            }

            var filterArr = [];

            if (this.searchTerm !== "") {
                this.allFlagSettings.forEach((quote) => {
                    if (
                        quote.location.name
                            .toLowerCase()
                            .includes(this.searchTerm.toLowerCase()) ||
                        quote.user.name
                            .toLowerCase()
                            .includes(this.searchTerm.toLowerCase()) ||
                        quote.status
                            .toLowerCase()
                            .includes(this.searchTerm.toLowerCase())
                    ) {
                        filterArr.push(quote);
                    }
                });
            }

            return filterArr;
        },
    },
    watch: {
        paginatedFlagSettings(newVal, oldVal) {
            // this.onPageChanged(newPage);
        },
    },
    mounted() {
        this.getAllFlagSettings();
    },
    methods: {
        updateRow(val) {
            this.paginatedFlagSettings = val;
        },
        openModal(data, type, defaultSetting) {
            this.modalType = type;
            this.modalData = data;
            this.modalSetting = defaultSetting;
            this.modalShow = !this.modalShow;
        },
        closeModal() {
            this.modalShow = !this.modalShow;
            this.getAllFlagSettings();
        },
        
    },
};
</script>
